import { produce } from "immer";
import { Actions } from "./action";

export interface EurocodeExceptionsState {
    exceptions: EurocodeException[];
    editingId: string | null;
}

const initialState: EurocodeExceptionsState = {
    exceptions: [],
    editingId: null
};

export const reducer = (state = initialState, action: Actions): EurocodeExceptionsState =>
    produce(state, draft => {
        if (action.type === "SET_EUROCODE_EXCEPTIONS") {
            draft.exceptions = action.exceptions;
            return;
        }
        if (action.type === "ADD_EUROCODE_EXCEPTION") {
            draft.exceptions.push(action.exception);
            return;
        }
        if (action.type === "UPDATE_EUROCODE_EXCEPTION") {
            const index = draft.exceptions.findIndex(e => e.id === action.exception.id);
            if (index > -1) {
                draft.exceptions[index] = action.exception;
            }
            return;
        }
        if (action.type === "DELETE_EUROCODE_EXCEPTION") {
            draft.exceptions = draft.exceptions.filter(e => e.id !== action.id);
            return;
        }
    });

export const getEurocodeExceptions = (state: EurocodeExceptionsState) => state.exceptions;

export default reducer;
